// POM-6112: a physical count locks one NDC, but its banners also list the other NDCs of the same
// product. These are the tooltips that tell the two apart. They live here because the Inventory
// Dashboard banner and the Bulk Queue banner must say exactly the same thing.

export const LOCKED_NDC_TOOLTIP = 'This NDC is locked for the count';

export const SIBLING_NDC_TOOLTIP =
  'Same product as the locked NDC — shown for reference, not itself locked';

export const getLockChipTooltip = (isLocked) =>
  isLocked ? LOCKED_NDC_TOOLTIP : SIBLING_NDC_TOOLTIP;
